export default __webpack_public_path__ + "static/blur-cyan-dbb963345bbc5680fe39385336a337fc.png";